<template>
  <div class="main-container" style="background: #f7f7f7">
    <div class="main-content-wrap" style="background: #f7f7f7">
      <div
        class="main-content-pannel flex flex-col main-content-pannel-t wrapper"
      >
        <div>
          <div>
            <div class="title">Payment</div>
            <div class="payment-wrapper">
              <div
                class="payment-item"
                v-for="(item, index) in paymentMethods"
                :key="index"
              >
                <div class="payment-item-header">
                  <img class="payment-item-header-img" :src="item.logo" />

                  <div class="payment-item-header-text">
                    <div>{{ item.name }}</div>
                  </div>
                </div>
                <div class="payment-item-divider" />
                <div class="payment-item-footer">
                  <div v-if="item.type === 'card'" class="card-tag">
                    <img class="tag-img" src="@/assets/image/card-icon.svg" />
                    <div>Credit Card</div>
                  </div>
                  <div
                    v-if="item.type === 'bankAccount'"
                    class="bankaccount-tag"
                  >
                    <img
                      class="tag-img"
                      src="@/assets/image/bankaccount-icon.svg"
                    />
                    <div>Bank Account</div>
                  </div>
                  <div>
                    <a
                      v-if="
                        (item.status == 'new' ||
                          item.status == 'verification_failed') &&
                        item.type == 'bankAccount'
                      "
                      href="javascript:void(0)"
                      @click="verifyBankAccount(item.id)"
                      >Verify</a
                    >
                    <a
                      href="javascript:void(0)"
                      @click="deletePaymentMethod(item, index)"
                      >Remove</a
                    >
                  </div>
                </div>
              </div>
              <div class="payment-method payment-method-add payment-item-add">
                <a href="javascript:void(0)" @click="addPaymentMethod">
                  <span>
                    <i class="material-icons-outlined align-middle">add</i>Add
                    payment method
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="table-wrapper">
          <div class="table-title">Invoices</div>
          <ag-grid-vue
            style="width: 100%; height: 300px"
            class="ag-theme-material"
            :gridOptions="invoiceGridOptions"
            :columnDefs="invoiceColumnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="invoiceRowData"
          ></ag-grid-vue>
        </div>
        <div class="table-wrapper">
          <div class="table-title">Payments</div>
          <ag-grid-vue
            style="width: 100%; height: 300px"
            class="ag-theme-material"
            :gridOptions="gridOptions"
            :columnDefs="columnDefs"
            @column-resized="onColumnResized"
            @first-data-rendered="onFirstDataRendered"
            @grid-size-changed="onFirstDataRendered"
            :rowData="rowData"
          ></ag-grid-vue>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelPayment
            v-if="editOpen == 1"
            :submitLoading="paymentSubmitLoading"
            @buttonClick="onPaymentButtonClick"
          ></PanelPayment>
          <PanelVerify
            v-if="editOpen == 2"
            :submitLoading="verifySubmitLoading"
            @buttonClick="onVerifyButtonClick"
          ></PanelVerify>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import { httpGet } from "@/http/http";
import * as utils from "@/utils/utils";
import PanelPayment from "@/components/client/clientPayment/PanelPayment.vue";
import PanelVerify from "@/components/client/clientPayment/PanelVerify.vue";
import GridInvoiceLink from "@/components/admin/companyAdmin/GridInvoiceLink.vue";

const PAYMENT_TYPE = {
  CARD: "card",
  BANK_ACCOUNT: "bankAccount",
};

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      queryId: null,
      company: null,

      paymentMethods: null,

      editOpen: false,

      gridOptions: {},
      columnDefs: null,
      rowData: null,

      invoiceGridOptions: {},
      invoiceColumnDefs: null,
      invoiceRowData: null,

      verifyBankAccountId: null,
      paymentSubmitLoading: false,
      verifySubmitLoading: false,
    };
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    company() {
      if (this.company.stripe_id) {
        this.updatePaymentData();
        this.updatePaymentMethodData();
        this.updateInvoiceData();
      } else {
        this.$router.push("/home/no_client_payment_account").catch((err) => {});
      }
    },
  },
  components: {
    EditPannel,
    OptionMenu,
    AgGridVue,
    PanelPayment,
    PanelVerify,
    GridInvoiceLink,
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    this.initColumnDefs();
    this.bindData();
  },
  methods: {
    initColumnDefs: function () {
      this.gridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.columnDefs = [
        { headerName: "Created", field: "created" },
        { headerName: "Amount", field: "amount" },
        { headerName: "Description", field: "description" },
        { headerName: "Status", field: "status" },
        { headerName: "ID", field: "id" },
      ];
      this.invoiceGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        context: {
          componentParent: this,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.invoiceColumnDefs = [
        {
          headerName: "Created",
          field: "created",
        },
        { headerName: "Toal", field: "total" },
        { headerName: "Status", field: "status" },
        {
          headerName: "Link",
          field: "url",
          cellRendererFramework: "GridInvoiceLink",
        },
        { headerName: "ID", field: "id" },
      ];
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    bindData: function () {
      if (this.queryId) {
        this.$bind("company", db.collection("companies").doc(this.queryId));
      }
    },
    updatePaymentData: function () {
      this.rowData = [];
      const stripeId = this.company.stripe_id;
      if (stripeId) {
        httpGet("get_payment_by_stripe_id", { stripeId }).then((response) => {
          if (response.ok) {
            const paymentData = response.data;
            paymentData.sort((a, b) => b.created - a.created);
            paymentData.forEach((item) => {
              item.created = utils.dateformat(
                item.created,
                "MM/DD/YYYY HH:mm A"
              );
              item.amount = "$" + (item.amount / 100).toFixed(2);
            });
            this.rowData = paymentData;
          }
        });
      }
    },
    updateInvoiceData: function () {
      this.invoiceRowData = [];
      const stripeId = this.company.stripe_id;
      if (stripeId) {
        httpGet("get_invoice", { stripeId }).then((response) => {
          if (response.ok) {
            const invoiceData = response.data;
            invoiceData.sort((a, b) => b.created - a.created);
            invoiceData.forEach((item) => {
              item.created = utils.dateformat(
                item.created,
                "MM/DD/YYYY HH:mm A"
              );
              item.total = "$" + (item.total / 100).toFixed(2);
            });
            this.invoiceRowData = invoiceData;
          }
        });
      }
    },
    updatePaymentMethodData: function () {
      const stripeId = this.company.stripe_id;
      if (stripeId) {
        httpGet("get_payment_method_by_stripe_id", { stripeId }).then(
          (response) => {
            this.paymentMethods = [];
            if (response.ok) {
              const cardResult = response.data.card_result;
              // const cardResult = [
              //   {
              //     id: 1,
              //     last4: "1234",
              //     exp_year: "2021",
              //   },
              // ];
              cardResult.forEach((item) => {
                this.paymentMethods.push({
                  type: PAYMENT_TYPE.CARD,
                  id: item.id,
                  name: "Credit card *" + item.card.last4,
                  logo: item.card.brand
                    ? "https://logo.clearbit.com/" +
                      item.card.brand.replace(/\s/g, "") +
                      ".com"
                    : "@/assets/image/logo.png",
                });
              });
              const bankAccountResult = response.data.bank_account_result;
              // const bankAccountResult = [
              //   {
              //     id: 1,
              //     last4: "0123",
              //   },
              // ];
              bankAccountResult.forEach((item) => {
                this.paymentMethods.push({
                  type: PAYMENT_TYPE.BANK_ACCOUNT,
                  id: item.id,
                  name: "Bank account *" + item.last4,
                  status: item.status,
                  logo: item.bank_name
                    ? "https://logo.clearbit.com/" +
                      item.bank_name.replace(/\s/g, "") +
                      ".com"
                    : "@/assets/image/logo.png",
                });
              });
            }
          }
        );
      }
    },
    addPaymentMethod: function () {
      this.openEditPannel(1, "Add Payment Method", true);
    },
    deletePaymentMethod: function (item, index) {
      // console.log(item, index);
      const stripeId = this.company.stripe_id;
      if (stripeId) {
        if (item.type == PAYMENT_TYPE.BANK_ACCOUNT) {
          utils.deleteConfirm(() => {
            httpGet("delete_client_bank_account", {
              stripeId,
              bankAccountId: item.id,
            }).then((response) => {
              if (response.ok) {
                this.$toasted.global.toast_success({
                  message: "delete success",
                });
                this.paymentMethods.splice(index, 1);
              } else {
                this.$toasted.global.toast_error({
                  message: "delete error",
                });
              }
            });
          });
        } else if (item.type == PAYMENT_TYPE.CARD) {
          utils.deleteConfirm(() => {
            httpGet("delete_client_credit_card", {
              paymentMethodId: item.id,
            }).then((response) => {
              if (response.ok) {
                this.$toasted.global.toast_success({
                  message: "delete success",
                });
                this.paymentMethods.splice(index, 1);
              } else {
                this.$toasted.global.toast_error({
                  message: "delete error",
                });
              }
            });
          });
        }
      }
    },
    onPaymentButtonClick: function (type, data) {
      const stripeId = this.company.stripe_id;
      if (stripeId) {
        if (type == 1) {
          data.stripeId = stripeId;
          this.paymentSubmitLoading = true;
          httpGet("add_client_bank_account", data)
            .then((response) => {
              if (response.ok) {
                this.$toasted.global.toast_success({
                  message: "add success",
                });
                const data = response.data;
                this.paymentMethods.push({
                  type: PAYMENT_TYPE.BANK_ACCOUNT,
                  id: data.id,
                  name: "Bank: XXXXXXXX" + data.last4,
                  status: data.status,
                });
                this.closeEditPanel();
              } else {
                this.$toasted.global.toast_error({
                  message: "add error",
                });
              }
            })
            .finally(() => {
              this.paymentSubmitLoading = false;
            });
        } else if (type == 2) {
          data.stripeId = stripeId;
          this.paymentSubmitLoading = true;
          httpGet("add_client_credit_card", data)
            .then((response) => {
              // console.log(response);
              if (response.ok) {
                this.$toasted.global.toast_success({
                  message: "add success",
                });
                const data = response.data;
                this.paymentMethods.push({
                  type: PAYMENT_TYPE.CARD,
                  id: data.id,
                  name: "Card: XXXX-XXXX-XXXX-" + data.last4,
                  exp:
                    data.exp_month + "/" + String(data.exp_year).substr(2, 2),
                });
                this.closeEditPanel();
              } else {
                this.$toasted.global.toast_error({
                  message: "add error",
                });
              }
            })
            .finally(() => {
              this.paymentSubmitLoading = false;
            });
        }
      }
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    verifyBankAccount: function (bankAccountId) {
      if (bankAccountId) {
        this.verifyBankAccountId = bankAccountId;
        this.openEditPannel(2, true);
      }
    },
    onVerifyButtonClick: function (deposit1, deposit2) {
      const bankAccountId = this.verifyBankAccountId;
      const data = {
        stripeId: this.company.stripe_id,
        bankAccountId: bankAccountId,
        deposit1: deposit1,
        deposit2: deposit2,
      };
      this.verifySubmitLoading = true;
      httpGet("verify_client_bank_account", data)
        .then((response) => {
          if (response.ok) {
            this.closeEditPanel();
            this.$toasted.global.toast_success({
              message: "verify success",
            });
            this.paymentMethods.forEach((item) => {
              if (item.id == bankAccountId) {
                item.status = "verified";
                return;
              }
            });
          } else {
            this.$toasted.global.toast_error({
              message: response.message,
            });
          }
        })
        .finally(() => {
          this.verifySubmitLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.wrapper {
  margin: 66px 44px;
  padding: 0;
}
.wrapper * {
  box-sizing: border-box;
}
.wrapper .ag-row {
  min-height: 64px !important;
}
.title {
  font-weight: 500;
  font-size: 36px;
  line-height: 48px;
  color: #1c1c1c;
  font-family: inter-regular;
}
.payment-wrapper {
  display: flex;
  margin-top: 13px;
  flex-wrap: wrap;
}
.payment-wrapper > :not(:last-child) {
  margin-right: 18px;
}
.payment-item {
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  padding: 16px;
  min-width: 264px;
  min-height: 108px;
}
.payment-item-header {
  display: flex;
  align-items: center;
}
.payment-item-header-img {
  width: 32px;
  height: 32px;
  margin-right: 8px;
}
.payment-item-header-text {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #1c1c1c;
  font-family: inter-regular;
}
.payment-item-divider {
  height: 1px;
  background: #e8e8e8;
  margin: 12px 0 8px;
}
.payment-item-footer {
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: inter-regular;
  font-weight: 500;
}
.bankaccount-tag {
  display: flex;
  align-items: center;
  background: linear-gradient(
      0deg,
      rgba(255, 150, 27, 0.1),
      rgba(255, 150, 27, 0.1)
    ),
    #ffffff;
  border-radius: 6px;
  padding: 2px 6px;
  color: #f98600;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  font-family: inter-regular;
}
.card-tag {
  display: flex;
  align-items: center;
  background: linear-gradient(
      0deg,
      rgba(0, 133, 255, 0.1),
      rgba(0, 133, 255, 0.1)
    ),
    #ffffff;
  border-radius: 6px;
  padding: 2px 6px;
  color: #0085ff;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  font-family: inter-regular;
}
.tag-img {
  width: 12px;
  height: 12px;
  margin-right: 4px;
}
.payment-item-add {
  margin: 0;
  width: 264px;
}
.table-wrapper {
  margin-top: 25px;
  background: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 2px 1px rgba(0, 0, 0, 0.06),
    0px 1px 1px rgba(0, 0, 0, 0.08);
  min-height: 358px;
}
.table-title {
  padding: 24px 24px 6px;
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  color: #1c1c1c;
  font-family: inter-regular;
}
</style>
